import React from 'react';
import { DragDropContext } from "react-beautiful-dnd";
import HorizontalDragComponent from "./HorizontalDragComponent";
import TagsDropDown from "./TagsDropDown";
import { KonfhubButton } from "../Buttons";
import MultipleOptionAddingModal from '../Modals/MultipleOptionAddingModal';

const TagsComponent = ({
	heading,
	addMultipleTagsButton,
	addMultipleTagsText,
	placeholder,
	dragEnd,
	tagsData,
	editIcon,
	editClickHandler,
	deleteIcon,
	deleteClickHandler,
	isDragDisabled,
	handleChange,
	value,
	CheckboxDropdownData,
	openSelectTicketDropdown,
	setOpenSelectTicketDropdown,
	onValueSelect,
	isChecked,
	addTagHandler,
	mandatory,
	onKeyDownHandler,
	handleMultipleTagsSave,
	openAddMultipleTags,
	setOpenMultipleTags,
	multipleOptionsValues,
	setMultipleOptionValues,
	addNewValueinDropDown,
	addSpeakers,
	addSpeakerClickHandler,
	openDropDown,
	noDataText,
	showNoDataMessage,
}) => {
	return (
		<div>
			<div className='d-flex justify-content-between'>
				<label className='label'>
					{heading}
					{mandatory && <span className='text-danger'>*</span>}
				</label>
				{addMultipleTagsButton &&
					<KonfhubButton btnType="secondary" className="mb-3" onClick={() => setOpenMultipleTags(true)}>
						Add Multiple Tags
					</KonfhubButton>
				}
				{addMultipleTagsText &&
					<label className='multiple-tags-text' onClick={() => setOpenMultipleTags(true)}>
						Add Multiple Tags
					</label>}
			</div>
			<div type="text" className="input tags-input" id="tags" name="tags">
				<div className="w-100">
					{tagsData && tagsData.length > 0 && (
						<DragDropContext onDragEnd={dragEnd}>
							<HorizontalDragComponent
								tagsData={tagsData}
								editIcon={editIcon}
								editClickHandler={editClickHandler}
								deleteIcon={deleteIcon}
								deleteClickHandler={deleteClickHandler}
								isDragDisabled={isDragDisabled}
							></HorizontalDragComponent>
						</DragDropContext>
					)}

					<input
						value={value}
						onChange={handleChange}
						onKeyDown={onKeyDownHandler}
						className="input-classname my-1"
						placeholder={placeholder}
						onClick={openDropDown}
					/>
				</div>
			</div>
			{!!openSelectTicketDropdown && (
				<TagsDropDown
					data={CheckboxDropdownData}
					noData={`Add "${value}" as a new tag`}
					openSelectTicketDropdown={openSelectTicketDropdown}
					onClick={(e, val) => {
						onValueSelect(e, val);
					}}
					openSelectDropdown={openSelectTicketDropdown}
					setOpenSelectTicketDropdown={setOpenSelectTicketDropdown}
					value={value}
					isChecked={isChecked}
					addTagHandler={addTagHandler}
					addNewValueinDropDown={addNewValueinDropDown}
					addSpeakers={addSpeakers}
					addSpeakerClickHandler={addSpeakerClickHandler}
					noDataText={noDataText}
					showNoDataMessage={showNoDataMessage}
				/>
			)}
			{openAddMultipleTags &&
				<MultipleOptionAddingModal
					header={"Add Multiple Tags"}
					openTextAreaModal={openAddMultipleTags}
					setOpenTextAreaModal={setOpenMultipleTags}
					multipleOptionsValues={multipleOptionsValues}
					onChange={setMultipleOptionValues}
					closeButton={true}
					saveButton={true}
					closeButtonText={"Cancel"}
					saveButtonText={"Add"}
					handleSave={handleMultipleTagsSave}
				/>}
			<style>
				{`
					.tags-input{
						width: 100%;
						height: 100%;
					}
					.input-classname{
						border: none;
						width: 100%;
					}
					.multiple-tags-text{
						font-family: Hind;
						font-size: 14px;
						font-weight: 400;
						line-height: 24px;
						color: #007BFF;
						cursor: pointer;
					}
				`}
			</style>
		</div>
	);
};

export default TagsComponent;
